import React, { useEffect, useRef, useState } from 'react';
import { MediaVideoFragment } from '@src/graphql/gql-types';
import classNames from 'classnames';
import MediaImage from '@src/components/MediaImage';
import VideoModal from '@src/components/VideoModal';
import styles from './MediaVideo.module.scss';
import { useRouter } from 'next/router';
import {
  ModalState,
  useModalOpenOrClose
} from '@src/hooks/useModalOpenOrClose';
import BoxIcon from '@src/elements/BoxIcon';

type MediaVideo = MediaVideoFragment & {
  id?: string | null;
  fillParent?: boolean;
};

const MediaVideo: React.FC<MediaVideo> = (mediaVideo) => {
  const videoName = (mediaVideo.caption || mediaVideo.id || 'video')
    .replace(/[^a-zA-Z0-9]/g, '')
    .toLowerCase();
  const [videoIsOpen, setModal] = useState<ModalState>({ open: false });
  const { handleOpen, handleClose } = useModalOpenOrClose(setModal, videoName);
  const router = useRouter();

  const mediaVideoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    router.beforePopState(() => {
      setModal({ open: false });
      return true;
    });
  }, [router.asPath, videoName, router]);

  const openModal = () => {
    handleOpen();
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    handleClose();
    document.body.style.overflow = 'auto';
  };

  return (
    <div
      ref={mediaVideoRef}
      className={classNames(styles.videoPreview, {
        [styles.fillParent]: mediaVideo.fillParent
      })}
    >
      {mediaVideo && <MediaImage {...mediaVideo} priority />}

      <button
        className={styles.playButton}
        onClick={openModal}
        aria-label={`Play Video`}
      >
        <BoxIcon name="play" size="lg" />
      </button>

      <VideoModal
        mediaVideo={mediaVideo}
        videoIsOpen={videoIsOpen.open}
        closeModal={() => {
          closeModal();
        }}
      />
    </div>
  );
};

export default MediaVideo;
